module.exports = __webpack_public_path__ + "img/66.26b0dd2f.png";